"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var label_exports = {};
__export(label_exports, {
  LabelEventType: () => LabelEventType
});
module.exports = __toCommonJS(label_exports);
var LabelEventType = /* @__PURE__ */ ((LabelEventType2) => {
  LabelEventType2["CreateLabel"] = "createLabel";
  LabelEventType2["RemoveLabel"] = "removeLabel";
  return LabelEventType2;
})(LabelEventType || {});
//# sourceMappingURL=label.js.map
